import React from 'react';

export const RenderCell = props => (props.value ? 'да' : 'нет');

export const Method = (filter, row) => {
  if (filter.value === 'true') {
    return row[filter.id];
  }

  return !row[filter.id];
};

export const Filter = ({ filter, onChange }) => (
  <select
    onChange={event => onChange(event.target.value)}
    style={{ width: '100%' }}
    value={filter && filter.value}
  >
    <option value=""> все </option>
    <option value="true"> да </option>
    <option value="false"> нет </option>
  </select>
);
